import React, { useContext, useEffect, useState, useRef } from 'react';
import './hero.scss';
import { AppContext } from '../../services/translationContext';
import { Link, useParams } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";

import "swiper/css";
import "swiper/css/effect-fade";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Autoplay, EffectFade, Navigation, Pagination } from "swiper";
import IconButton from '@mui/material/IconButton';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import PauseIcon from '@mui/icons-material/Pause';

export const Hero = () => {
  const { services: {TranslationsService} } = useContext(AppContext);
  const [listSlider, setListSlider] = useState([]);
  const [fullSlideSize, setfullSlideSize] = useState('');
  const [marginTopHero, setMarginTopHero] = useState('');
  const [displayScrollbar, setDisplayScrollbar] = useState('block');
  const [activeIndex, setActiveIndex] = useState(0);
  const [isPlaying, setIsPlaying] = useState(true);

  const { lang } = useParams();

  const swiperElRef = useRef(null);

  useEffect(() => {
    function shuffle(array) {
      const shuffled = [...array];
      for (let i = shuffled.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
      }
      return shuffled;
    }
    const shuffled = shuffle(TranslationsService.labels(`home_page.carousel`));
    setListSlider(shuffled);
  }, [TranslationsService]);

  useEffect(() => {
    let _navbar = document.getElementById('main-nav');
    setfullSlideSize(`100%`);

    try{
      if(window.getComputedStyle(_navbar).display === 'none'){
        _navbar = document.getElementById('main-nav-mob');
      }
      setMarginTopHero(`-${_navbar.offsetHeight + 1}px`);
    }
    catch(e){}

  }, []);

  const onSlideChange = (swiper) =>{
    setActiveIndex(swiper.realIndex);
    setDisplayScrollbar('none');
    setTimeout(() => {
      setDisplayScrollbar('block');
    }, 100);
  }

  const scrollDownHero = () =>{
    window.scrollTo(0, (window.innerHeight - 80));
  }

  return (
    <div className="hero-container">

      <div className='btn-scroll-down' onClick={scrollDownHero}>
        <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" className="bi bi-chevron-down" viewBox="0 0 16 16">
          <path fillRule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"/>
        </svg>
      </div>
      
      <Swiper
        ref={swiperElRef}
        spaceBetween={30}
        effect={"fade"}
        loop={true}
        autoplay={{
          delay: 10000,
          disableOnInteraction: false,
        }}
        // // navigation={true}
        // // pagination={{
        // //   type: "progressbar",
        // // }}
        // // pagination={true}
        modules={[Autoplay, EffectFade, Navigation, Pagination]}
        className="swiper-hero"
        style={{height: fullSlideSize, marginTop: marginTopHero}}
        onSlideChange={onSlideChange}
        // onSlideChange={() => onSlideChange()}
      >
        {
          listSlider.map((slider, i) => (
          // <SwiperSlide key={i}>
          //   {slider.internal_link || slider.external_link ? (
          //     slider.internal_link ? (
          //       <Link to={`/${lang}${slider.internal_link}`} className='text-deco-none transition-03s-eio'>
          //         <div className='slide-home-hero pos-relative'>
          //           <div className='slide-overlay p-5'>
          //             <div className='col-slide-hero d-flex flex-column justify-content-center pt-5'>
          //               <h2 className='dark-mode-text fw-bold slide-hero-title'>{slider.title}</h2>
          //               <div className='box-action-hero d-flex align-items-center gap-2 transition-03s-eio'>
          //                 <span className='m-0 p-0'>{TranslationsService.labels(`learn_more`)}</span>
          //                 <span className='box-arrow-hero'>
          //                   <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" className="bi bi-arrow-right" viewBox="0 0 16 16">
          //                     <path fillRule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8z"/>
          //                   </svg>
          //                 </span>
          //               </div>
          //             </div>
          //           </div>
          //           <img src={slider.image} alt={slider.title} className='img-slide-hero'/>
          //         </div>
          //       </Link>
          //     ) : (
          //       <a href={slider.external_link} target='_blank' rel='noreferrer' className='text-deco-none transition-03s-eio'>
          //         <div className='slide-home-hero pos-relative'>
          //           <div className='slide-overlay p-5'>
          //             <div className='col-slide-hero d-flex flex-column justify-content-center pt-5'>
          //               <h2 className='dark-mode-text fw-bold slide-hero-title'>{slider.title}</h2>
          //               <div className='box-action-hero d-flex align-items-center gap-2 transition-03s-eio'>
          //                 <span className='m-0 p-0'>{TranslationsService.labels(`learn_more`)}</span>
          //                 <span className='box-arrow-hero'>
          //                   <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" className="bi bi-arrow-right" viewBox="0 0 16 16">
          //                     <path fillRule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8z"/>
          //                   </svg>
          //                 </span>
          //               </div>
          //             </div>
          //           </div>
          //           <img src={slider.image} alt={slider.title} className='img-slide-hero'/>
          //         </div>
          //       </a>
          //     )
          //   ) : (
          //     <div className='slide-home-hero pos-relative'>
          //       <div className='slide-overlay p-5'>
          //         <div className='col-slide-hero d-flex flex-column justify-content-center pt-5'>
          //           <h2 className='dark-mode-text fw-bold slide-hero-title'>{slider.title}</h2>
          //         </div>
          //       </div>
          //       <img src={slider.image} alt={slider.title} className='img-slide-hero'/>
          //     </div>
          //   )}
          // </SwiperSlide>
          <SwiperSlide key={i}>
            {slider.internal_link || slider.external_link ? (
              // <Link to={`/${lang}${slider.internal_link}`} className='text-deco-none transition-03s-eio'>
                <div className='slide-home-hero pos-relative'>
                  <div className='slide-overlay p-5'>
                    <div className='col-slide-hero d-flex flex-column justify-content-center pt-5'>
                      <h2 className='dark-mode-text fw-bold slide-hero-title font-title'>{slider.title}</h2>
                      { slider.subtitle && <h3 className='dark-mode-text slide-hero-subtitle'>{slider.subtitle}</h3> }
                      <div className='box-action-hero d-flex align-items-center gap-2 transition-03s-eio'>
                        {
                          slider.internal_link ? (
                            <Link to={`/${lang}${slider.internal_link}`} className='text-deco-none transition-03s-eio btn-discover-slider'>
                              <span className='m-0 p-0'>{slider.callToAction ? TranslationsService.labels(slider.callToAction) : TranslationsService.labels(`learn_more`)}</span>
                            </Link>
                          )
                          :
                          (
                            <a href={slider.external_link} target='_blank' rel='noreferrer' className='text-deco-none transition-03s-eio btn-discover-slider'>
                              <span className='m-0 p-0'>{slider.callToAction ? TranslationsService.labels(slider.callToAction) : TranslationsService.labels(`learn_more`)}</span>
                            </a>
                          )
                        }
                      </div>
                    </div>
                  </div>
                  <img src={slider.image} alt={slider.title} className='img-slide-hero'/>
                </div>
              // </Link>
              // slider.internal_link ? (
              //   <Link to={`/${lang}${slider.internal_link}`} className='text-deco-none transition-03s-eio'>
              //     <div className='slide-home-hero pos-relative'>
              //       <div className='slide-overlay p-5'>
              //         <div className='col-slide-hero d-flex flex-column justify-content-center pt-5'>
              //           <h2 className='dark-mode-text fw-bold slide-hero-title'>{slider.title}</h2>
              //           <div className='box-action-hero d-flex align-items-center gap-2 transition-03s-eio'>
              //             <span className='m-0 p-0'>{TranslationsService.labels(`learn_more`)}</span>
              //             <span className='box-arrow-hero'>
              //               <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" className="bi bi-arrow-right" viewBox="0 0 16 16">
              //                 <path fillRule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8z"/>
              //               </svg>
              //             </span>
              //           </div>
              //         </div>
              //       </div>
              //       <img src={slider.image} alt={slider.title} className='img-slide-hero'/>
              //     </div>
              //   </Link>
              // ) : (
              //   <a href={slider.external_link} target='_blank' rel='noreferrer' className='text-deco-none transition-03s-eio'>
              //     <div className='slide-home-hero pos-relative'>
              //       <div className='slide-overlay p-5'>
              //         <div className='col-slide-hero d-flex flex-column justify-content-center pt-5'>
              //           <h2 className='dark-mode-text fw-bold slide-hero-title'>{slider.title}</h2>
              //           <div className='box-action-hero d-flex align-items-center gap-2 transition-03s-eio'>
              //             <span className='m-0 p-0'>{TranslationsService.labels(`learn_more`)}</span>
              //             <span className='box-arrow-hero'>
              //               <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" className="bi bi-arrow-right" viewBox="0 0 16 16">
              //                 <path fillRule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8z"/>
              //               </svg>
              //             </span>
              //           </div>
              //         </div>
              //       </div>
              //       <img src={slider.image} alt={slider.title} className='img-slide-hero'/>
              //     </div>
              //   </a>
              // )
            ) : (
              <div className='slide-home-hero pos-relative'>
                <div className='slide-overlay p-5'>
                  <div className='col-slide-hero d-flex flex-column justify-content-center pt-5'>
                    <h2 className='dark-mode-text fw-bold slide-hero-title font-title'>{slider.title}</h2>
                  </div>
                </div>
                <img src={slider.image} alt={slider.title} className='img-slide-hero'/>
              </div>
            )}
          </SwiperSlide>
          ))
        }
        
        {/* <div className='hero-progressbar' style={{display:displayScrollbar}}></div> */}
        {
          listSlider && listSlider.length >0 &&
          <div className='box-progress-bar'>
            <div>            
                <IconButton style={{color: '#fcfcfc'}} onClick={() => swiperElRef.current.swiper.slidePrev()} size='small'>
                <ArrowBackIcon />
              </IconButton>
              <IconButton style={{color: '#fcfcfc'}} onClick={() => {
                const swiper = swiperElRef.current.swiper;
                if (isPlaying) {
                  swiper.autoplay.pause();
                } else {
                  swiper.autoplay.resume();
                }
                setIsPlaying(!isPlaying);
              }}>
                {isPlaying ? <PauseIcon /> : <PlayArrowIcon />}
              </IconButton>
            </div>
            {listSlider.map((_, i) => (
              <div className={`hero-progress-segment ${activeIndex === i ? 'active' : ''}`} key={i} onClick={() => {
                if (swiperElRef.current && swiperElRef.current.swiper) {
                  swiperElRef.current.swiper.slideToLoop(i);
                }
              }}>
                {activeIndex === i && (
                  <div
                    key={activeIndex}
                    className={`hero-progress-fill ${!isPlaying ? 'paused' : ''}`}
                  />
                )}
              </div>
            ))}
            <div>
              <IconButton style={{color: '#fcfcfc'}}  onClick={() => swiperElRef.current.swiper.slideNext()}>
                <ArrowForwardIcon />
              </IconButton>
            </div>
          </div>
        }
      </Swiper>
    </div>
  );
};